module.exports = __webpack_public_path__ + "img/like-thick.bc9868cf.svg";